import React from 'react';
import { UnpaidAlertNotificationUi } from './ui';
import { MyProfileData } from 'cpfr-common';

export type UnpaidAlertNotificationProps = {
    amountUnpaidNotPaid: number;
    contractId?: string;
    myProfile?: MyProfileData;
};

export const UnpaidAlertNotification: React.FC<UnpaidAlertNotificationProps> = ({
    amountUnpaidNotPaid,
    myProfile,
    contractId,
}) => {
    return (
        <UnpaidAlertNotificationUi
            amountUnpaidNotPaid={amountUnpaidNotPaid}
            myProfile={myProfile}
            contractId={contractId}
        />
    );
};
